import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const MAX_FEEDBACK_CHARS = 500;

const FeedbackForm = ({
  isOpen,
  messageId,
  onClose,
  onSubmit,
  isLoading,
  errorMessage
}) => {
  const [feedbackText, setFeedbackText] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setFeedbackText('');
    }
  }, [isOpen, messageId]);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(feedbackText.trim());
  };

  const handleChange = (event) => {
    if (event.target.value.length <= MAX_FEEDBACK_CHARS) {
      setFeedbackText(event.target.value);
    }
  };

  const handleOverlayClick = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const handleDialogClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div
      className="chatbot-feedback-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Feedback form"
      onClick={handleOverlayClick}
    >
      <form className="chatbot-feedback-form" onSubmit={handleSubmit} onClick={handleDialogClick}>
        <h3>Why was this response unhelpful?</h3>
        <p className="chatbot-feedback-subtitle">Your feedback helps us improve.</p>
        <textarea
          aria-label="Feedback details"
          value={feedbackText}
          onChange={handleChange}
          placeholder="Tell us what went wrong..."
          maxLength={MAX_FEEDBACK_CHARS}
          required
        />
        <div className="chatbot-feedback-char-count">
          {feedbackText.length}/{MAX_FEEDBACK_CHARS}
        </div>
        {errorMessage && <div className="chatbot-feedback-error" role="alert">{errorMessage}</div>}
        <div className="chatbot-feedback-actions">
          <button type="button" onClick={onClose} disabled={isLoading}>No thanks</button>
          <button type="submit" disabled={isLoading || !feedbackText.trim()}>
            {isLoading ? (
              <span className="chatbot-feedback-submit-content">
                <span className="chatbot-feedback-spinner" aria-hidden="true" />
                <span>Submitting...</span>
              </span>
            ) : 'Submit'}
          </button>
        </div>
      </form>
    </div>
  );
};

FeedbackForm.propTypes = {
  isOpen: PropTypes.bool,
  messageId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string
};

FeedbackForm.defaultProps = {
  isOpen: false,
  messageId: '',
  isLoading: false,
  errorMessage: ''
};

export default FeedbackForm;
